import { any } from "cypress/types/bluebird";
import { StudentDebtType } from "../../../types/Finance";
import { StudentType } from "../../../types/Student";
import { UserType } from "../../../types/User";
import { useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { TokenResponseType } from "../../../types/TokenResponse";

export const invoicePayload =(data:{
     studentDebt: StudentDebtType;
     student: StudentType;
     user: UserType;
     IES: any;
     loggedUserData : TokenResponseType;
     logoBase64?: string;
}) => {
    const {studentDebt, student, user, IES, loggedUserData, logoBase64} = data;
  

    return {
        type: "INVOICE",
    outputformat: "PDF",
    data: {
      ies: IES?.NAME ?? "",
      endereco: IES?.COUNTRY ?? "",
      nuit: IES?.NUIT ?? "",
      unidade: IES?.ENROLLMENT_DEPARTAMENT_NAME ?? "",
      telefone: IES?.PHONE_NUMBER ?? "",
      email: IES?.EMAIL ?? "",
      servico: studentDebt.paymentType ?? "N/D",
      utilizador: loggedUserData?.Fullname ?? "N/D",
      semestre: student?.semester ?? "N/D",
      nr_factura: studentDebt.code ?? "N/D",
      data: new Date().toLocaleDateString(),
      total: studentDebt.currentAmount.toFixed(2),
      sub_total: studentDebt.currentAmount.toFixed(2),
      nome_est: studentDebt.fullname ?? "N/D",
      codigo_est:student.schoolCode ?? "N/D",
      nr_est: user?.phoneNumber ?? "N/D",
      nuit_est: user?.nuit ?? "N/D",
      email_est: user?.email ?? "N/D",
      endereco_est: "N/D",
      banco: studentDebt.bankName ?? "N/D",
      entidade: studentDebt.entityCode ?? "N/D",
      referencia: studentDebt.referenceCode ?? "N/D",
      descricao: studentDebt.description ?? "N/D",
      desconto_total: "0.00",
      nome_departamento: "Direcção de Administração Financeira",
      multa: "0.00",
          base_iva: "0.00",
          total_iva: "0.00",
          desconto: "0.00",
      tabela: [
        {
          quantidade: "1",
          preco_unitario: studentDebt.currentAmount.toFixed(2),
          Servico_tabela: studentDebt.paymentType ?? "N/D",
          desconto: "0.00",
          codigo: studentDebt.code ?? "N/D",
          importancia: studentDebt.currentAmount.toFixed(2),
        },
      ],
    },
     logoBase64: logoBase64 ?? "",
     
};

}